export default __webpack_public_path__ + "d70d3f02774c12b1c807809665949fa2.jpg";